var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { EmberBridgeContainer } from '@ally/ember-bridge-container';
import AosStkProgressBar from './AosStkProgressBar';
/**
 * Provides the @ally/metronome-theme via a <ThemeProvider /> and wraps the
 * AosStkProgressBar component with a <BrowserRouter />.
 */
export default (function (props) {
    return (React.createElement(EmberBridgeContainer, null,
        React.createElement(AosStkProgressBar, __assign({}, props))));
});
//# sourceMappingURL=index.js.map